/* eslint-disable import/no-cycle */
import React, { useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { defineMessages } from "react-intl"
import Box from "@material-ui/core/Box"
import { Container, Paper } from "@material-ui/core"
import PageSubTitle from "../../component/header/PageSubTitle"
import DashboardWidget from "../../component/widgets/DashboardWidget"
import DateSelectorWidget from "../../component/widgets/DateSelectorWidget"
import { CustomersSelector, PortfoliosSelector } from "./Selectors"
import widgetSlice, {
  SYNTHESIS_END_DATE_SELECTOR_ID
} from "../../api/widgetSlice"
import useSmartFormat from "../../i18n/useSmartFormat"
import { PAGE_IDENTIFIER } from "./pages"

const messages = defineMessages({
  portfolioSummary: {
    defaultMessage: "Summary of your portfolios",
    id: "private.synthesis.subtitle"
  },
  portfolioDetails: {
    defaultMessage: "Your portfolio in detail",
    id: "private.synthesis.portfolio.summary"
  }
})

const { selectedValueOf } = widgetSlice.select

export default function SynthesisCustomTab({ children }) {
  const endDateValue = useSelector(
    selectedValueOf(SYNTHESIS_END_DATE_SELECTOR_ID)
  )
  const pages = useSelector((state) => state.wealth.pages)
  const [hasMax, setHasMax] = useState(false)
  const format = useSmartFormat()
  const hidePortfolioDetails = useMemo(() => {
    const overviewPage = pages.find(
      ({ pageIdentifier }) => pageIdentifier === PAGE_IDENTIFIER.overview
    )
    setHasMax(overviewPage.dateIsLimited)
    return overviewPage?.customOptions?.hidePortfolioDetails ?? false
  }, [pages])

  return (
    <Box py={3}>
      <Container maxWidth="lg">
        <Box display="flex" justifyContent="center">
          <DateSelectorWidget
            widgetId={SYNTHESIS_END_DATE_SELECTOR_ID}
            defaultValue={endDateValue.toString()}
            label="Date"
            className="date-selector-min-width"
            hasMax={hasMax}
          />
        </Box>
        <PageSubTitle subtitle={format(messages.portfolioSummary)}>
          <CustomersSelector />
        </PageSubTitle>
        {children}
      </Container>
      <Container maxWidth="xl">
        <DashboardWidget
          widgetId="wealth_synthesis_dashboard_0"
          subscriptions={{
            customer_list: "wealth_customer_selector",
            end_date_list: "synthesis_end_date_selector"
          }}
          TableProps={{ renderTitle: () => "" }}
          ChartContainerProps={{ component: Paper, elevation: 0 }}
        />
      </Container>
      {!hidePortfolioDetails && (
        <>
          <Container maxWidth="lg">
            <PageSubTitle subtitle={format(messages.portfolioDetails)}>
              <PortfoliosSelector />
            </PageSubTitle>
            {children}
          </Container>

          <Container maxWidth="xl">
            <DashboardWidget
              widgetId="wealth_synthesis_dashboard_1"
              subscriptions={{
                end_date_list: "synthesis_end_date_selector",
                asset_list: "wealth_portfolio_selector"
              }}
              TableProps={{ renderTitle: () => "" }}
              ChartContainerProps={{ component: Paper, elevation: 0 }}
            />
          </Container>
        </>
      )}
    </Box>
  )
}

SynthesisCustomTab.propTypes = {
  subtitle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired
  }).isRequired,
  selectorReducerName: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

SynthesisCustomTab.defaultProps = {
  children: null
}
